/* Gouttes Rares — barometer animation engine.
 *
 * The barometer lives inside product descriptions as a flat PNG plus an SVG text
 * overlay, identical on all 134 products. This script leaves both untouched on
 * disk: it punches holes in the PNG with mask-image and stacks animated layers
 * into the gaps. Nothing here writes to the product body.
 *
 * Only the hourglass and the sillage veil need real artwork (the sand had to be
 * lifted off the glass, the veil off the figure). Everything else — sun, moon,
 * seasons, the lit occasion medallion — is a CSS window onto the base PNG the
 * browser has already downloaded, so it costs no extra bytes.
 */
(function () {
  'use strict';
  if (window.__grbaBooted) return;
  window.__grbaBooted = 1;

  var VW = 700, VH = 2032;                 // the overlay viewBox everything is measured in
  var HG_W = 1405, HG_H = 2607;            // hourglass artwork canvas

  var G = {
    hourglass: { box: [36, 46, 86, 160], cone: [0.17223, 0.54507], pile: [0.66705, 0.85079] },
    sillage:   { box: [6, 261, 140.5, 110] },
    windows: {
      sun:    [3, 1128.5, 141, 146],
      moon:   [603, 1150.5, 98, 102],
      winter: [19, 1369.5, 120, 148.5],
      spring: [26.5, 1538.5, 105, 117],
      summer: [26, 1705.5, 106, 86.5],
      fall:   [18, 1837, 122, 128]
    },
    wheel: { cx: 350, cy: 752, r: 224, mr: 103, hole: 101 }
  };

  /* theme.liquid hands us asset_url paths; these Files copies are the fallback. */
  var BASE = window.GRBA_BASE || 'https://cdn.shopify.com/s/files/1/0937/0340/5861/files/';
  var A = window.GRBA_ASSETS || {
    frame:  BASE + 'gr-baro-hg-frame.webp',
    cone:   BASE + 'gr-baro-hg-top.webp',
    pile:   BASE + 'gr-baro-hg-pile.webp',
    stream: BASE + 'gr-baro-hg-stream.webp',
    veil:   BASE + 'gr-baro-sil-veil.webp',
    upper:  BASE + 'gr-baro-sil-upper.webp',
    skirt:  BASE + 'gr-baro-sil-skirt.webp'
  };

  /* GR hourglass v2 (Claude 2026-10-25; owner: "the longevity icon doesn't animate correctly, looks glitchy").
     The old hourglass turned its sand with the glass, so after every turn the sand hung from the base and drained
     to a point in mid-air; the emptied glass was smeared pixels. Now the empty glass is its own clean layer and
     the sand never turns with it (see the longevity block in build() and hgStyle()). Layer art lives in Files. */
  var HG2 = window.GRBA_HG2 || {
    frame:  "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/barometer-longevity-hourglass-empty-brass-frame.webp?v=1792963399",
    sand:   "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/barometer-longevity-hourglass-golden-sand.webp?v=1792963402",
    stream: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/barometer-longevity-hourglass-falling-sand-stream.webp?v=1792963405"
  };
  /* The whole cycle, generated by gr-longevity-1025/tools/physics.py from the bulbs measured on the artwork
     (the same 1405 x 2607 canvas the old layers used): constant flow through the neck, the volume conserved
     between the bulbs, the visible sand held constant while the glass turns. Each key is
     [time %, glass angle, sand a, sand b, stream]; a sand entry is [] (none), [0, level, x, dip] (draining:
     a level surface with a small dip over the neck) or [1, apex, x, flat] (a cone of sand under the stream;
     flat runs 0 -> 1 as the cone slumps level while the glass turns); stream is [top, bottom, which neck]. */
  var HG2K = {"c":22.3,"k":[[0.0,0.0,[0,639.0,700.2,0],[1,2274,707.0,0.0],[1305.0,1305.0,0]],[1.1211,0.0,[0,639.0,700.2,0.0],[1,2274,707.0,0.0],[1305.0,1305.0,0]],[2.0179,0.0,[0,646.0,700.6,7.3],[1,2274,707.0,0.0],[1305.0,2214.0,0]],[3.139,0.0,[0,655.0,700.9,16.5],[1,2081.1,707.0,0.0],[1305.0,2087.1,0]],[4.2601,0.0,[0,664.0,701.0,25.7],[1,2046.7,707.0,0.0],[1305.0,2052.7,0]],[5.3812,0.0,[0,673.0,700.7,34.8],[1,2022.6,707.0,0.0],[1305.0,2028.6,0]],[6.5022,0.0,[0,681.0,700.2,44.0],[1,2003.3,707.0,0.0],[1305.0,2009.3,0]],[7.6233,0.0,[0,689.0,700.0,53.2],[1,1987.1,707.0,0.0],[1305.0,1993.1,0]],[8.7444,0.0,[0,698.0,700.0,55.0],[1,1972.9,707.0,0.0],[1305.0,1978.9,0]],[9.8655,0.0,[0,707.0,700.1,55.0],[1,1960.2,707.0,0.0],[1305.0,1966.2,0]],[10.9865,0.0,[0,715.0,700.4,55.0],[1,1948.7,707.0,0.0],[1305.0,1954.7,0]],[12.1076,0.0,[0,724.0,699.5,55.0],[1,1938.1,707.0,0.0],[1305.0,1944.1,0]],[13.2287,0.0,[0,733.0,697.0,55.0],[1,1927.9,707.0,0.0],[1305.0,1933.9,0]],[14.3498,0.0,[0,742.0,695.2,55.0],[1,1917.9,707.0,0.0],[1305.0,1923.9,0]],[15.4709,0.0,[0,751.0,695.6,55.0],[1,1907.7,707.0,0.0],[1305.0,1913.7,0]],[16.5919,0.0,[0,760.0,699.2,55.0],[1,1895.8,707.0,0.0],[1305.0,1901.8,0]],[17.713,0.0,[0,769.0,703.2,55.0],[1,1884.0,707.0,0.0],[1305.0,1890.0,0]],[18.8341,0.0,[0,779.0,706.5,55.0],[1,1872.6,707.0,0.0],[1305.0,1878.6,0]],[19.9552,0.0,[0,789.0,707.4,55.0],[1,1861.7,707.0,0.0],[1305.0,1867.7,0]],[21.0762,0.0,[0,799.0,708.6,55.0],[1,1851.2,707.0,0.0],[1305.0,1857.2,0]],[22.1973,0.0,[0,809.0,710.5,55.0],[1,1840.9,707.0,0.0],[1305.0,1846.9,0]],[23.3184,0.0,[0,820.0,712.5,55.0],[1,1831.0,707.0,0.0],[1305.0,1837.0,0]],[24.4395,0.0,[0,831.0,715.9,55.0],[1,1821.2,707.0,0.0],[1305.0,1827.2,0]],[25.5605,0.0,[0,842.0,726.4,55.0],[1,1811.5,707.0,0.0],[1305.0,1817.5,0]],[26.6816,0.0,[0,855.0,734.4,55.0],[1,1801.8,707.0,0.0],[1305.0,1807.8,0]],[27.8027,0.0,[0,868.0,735.2,55.0],[1,1792.1,707.0,0.0],[1305.0,1798.1,0]],[28.9238,0.0,[0,882.3,734.3,55.0],[1,1782.5,707.0,0.0],[1305.0,1788.5,0]],[30.0448,0.0,[0,897.0,732.4,55.0],[1,1773.1,707.0,0.0],[1305.0,1779.1,0]],[31.1659,0.0,[0,912.0,732.6,55.0],[1,1763.7,707.0,0.0],[1305.0,1769.7,0]],[32.287,0.0,[0,928.0,731.6,55.0],[1,1754.4,707.0,0.0],[1305.0,1760.4,0]],[33.4081,0.0,[0,945.0,731.5,55.0],[1,1745.2,707.0,0.0],[1305.0,1751.2,0]],[34.5291,0.0,[0,964.0,733.9,55.0],[1,1736.2,707.0,0.0],[1305.0,1742.2,0]],[35.6502,0.0,[0,985.0,734.2,53.0],[1,1727.2,707.0,0.0],[1305.0,1733.2,0]],[36.7713,0.0,[0,1009.0,735.2,42.8],[1,1718.3,707.0,0.0],[1305.0,1724.3,0]],[37.8924,0.0,[0,1038.0,723.0,32.6],[1,1709.4,707.0,0.0],[1305.0,1715.4,0]],[39.0135,0.0,[0,1079.0,724.6,22.4],[1,1700.6,707.0,0.0],[1305.0,1706.6,0]],[40.1345,0.0,[0,1117.0,730.0,12.2],[1,1691.6,707.0,0.0],[1305.0,1697.6,0]],[41.2556,0.0,[0,1186.0,722.8,2.0],[1,1682.4,707.0,0.0],[1305.0,1688.4,0]],[41.4798,0.0,[0,1345.0,707.0,0],[1,1680.6,707.0,0.0],[1305.0,1686.6,0]],[42.3767,0.0,[0,1345.0,707.0,0],[1,1673.2,707.0,0.0],[1679.2,1679.2,0]],[42.3812,0.0,[],[1,1673.2,707.0,0.0],[1305.0,1305.0,0]],[44.3946,0.0,[],[1,1673.2,707.0,0.0],[1305.0,1305.0,0]],[44.3969,0.0,[],[1,1672.1,707.0,0.0],[0,0,0]],[44.5816,0.35,[],[1,1673.9,704.8,0.002],[0,0,0]],[44.7682,1.48,[],[1,1676.2,697.4,0.011],[0,0,0]],[44.9552,3.55,[],[1,1680.3,684.1,0.032],[0,0,0]],[45.1422,6.76,[],[1,1681.4,663.5,0.069],[0,0,0]],[45.3287,11.36,[],[1,1680.8,634.1,0.128],[0,0,0]],[45.5157,17.65,[],[1,1675.5,594.7,0.217],[0,0,0]],[45.7027,25.99,[],[1,1654.1,544.5,0.346],[0,0,0]],[45.8892,36.68,[],[1,1615.1,485.2,0.523],[0,0,0]],[46.0762,49.77,[],[1,1540.5,423.1,0.754],[0,0,0]],[46.2632,64.73,[],[1,1421.9,370.1,1.0],[0,0,0]],[46.4498,80.42,[],[1,1257.9,338.7,1.0],[0,0,0]],[46.6368,95.53,[],[1,1113.9,334.0,1.0],[0,0,0]],[46.8238,109.19,[],[1,1009.9,351.8,1.0],[0,0,0]],[47.0103,121.09,[],[1,941.9,383.6,1.0],[0,0,0]],[47.1973,131.28,[],[1,889.9,421.7,1.0],[0,0,0]],[47.3843,139.95,[],[1,849.9,461.1,1.0],[0,0,0]],[47.5709,147.3,[],[1,817.9,498.9,1.0],[0,0,0]],[47.7578,153.52,[],[1,781.9,533.6,1.0],[0,0,0]],[47.9448,158.8,[],[1,757.9,564.6,1.0],[0,0,0]],[48.1314,163.25,[],[1,737.9,591.7,1.0],[0,0,0]],[48.3184,167.0,[],[1,725.9,615.0,1.0],[0,0,0]],[48.5054,170.14,[],[1,717.9,634.7,1.0],[0,0,0]],[48.6919,172.73,[],[1,713.9,651.3,1.0],[0,0,0]],[48.8789,174.85,[],[1,709.9,664.8,1.0],[0,0,0]],[49.0659,176.55,[],[1,705.9,675.7,1.0],[0,0,0]],[49.2525,177.86,[],[1,705.9,684.2,1.0],[0,0,0]],[49.4395,178.84,[],[1,705.9,690.5,1.0],[0,0,0]],[49.6265,179.5,[],[1,705.9,694.8,1.0],[0,0,0]],[49.813,179.88,[],[1,705.9,697.2,1.0],[0,0,0]],[50.0,180.0,[],[0,702.0,710.3,0],[0,0,0]],[50.0022,180.0,[1,2267,698.0,0.0],[0,702.0,710.3,0],[1302.0,1302.0,1]],[51.1211,180.0,[1,2267,698.0,0.0],[0,702.0,710.3,0.0],[1302.0,1302.0,1]],[52.0179,180.0,[1,2206.0,698.0,0.0],[0,709.0,710.8,7.3],[1302.0,2207.0,1]],[53.139,180.0,[1,2074.1,698.0,0.0],[0,718.0,711.3,16.5],[1302.0,2080.1,1]],[54.2601,180.0,[1,2039.7,698.0,0.0],[0,727.0,712.3,25.7],[1302.0,2045.7,1]],[55.3812,180.0,[1,2015.6,698.0,0.0],[0,736.0,713.4,34.8],[1302.0,2021.6,1]],[56.5022,180.0,[1,1996.3,698.0,0.0],[0,745.0,714.3,44.0],[1302.0,2002.3,1]],[57.6233,180.0,[1,1980.1,698.0,0.0],[0,753.2,714.9,53.2],[1302.0,1986.1,1]],[58.7444,180.0,[1,1965.9,698.0,0.0],[0,763.0,715.1,55.0],[1302.0,1971.9,1]],[59.8655,180.0,[1,1953.2,698.0,0.0],[0,772.0,715.2,55.0],[1302.0,1959.2,1]],[60.9865,180.0,[1,1941.4,698.0,0.0],[0,782.0,714.7,55.0],[1302.0,1947.4,1]],[62.1076,180.0,[1,1930.0,698.0,0.0],[0,791.0,714.0,55.0],[1302.0,1936.0,1]],[63.2287,180.0,[1,1919.2,698.0,0.0],[0,801.0,714.1,55.0],[1302.0,1925.2,1]],[64.3498,180.0,[1,1908.8,698.0,0.0],[0,811.0,714.1,55.0],[1302.0,1914.8,1]],[65.4709,180.0,[1,1898.7,698.0,0.0],[0,821.0,713.8,55.0],[1302.0,1904.7,1]],[66.5919,180.0,[1,1889.0,698.0,0.0],[0,831.0,714.7,55.0],[1302.0,1895.0,1]],[67.713,180.0,[1,1879.4,698.0,0.0],[0,841.0,715.5,55.0],[1302.0,1885.4,1]],[68.8341,180.0,[1,1869.8,698.0,0.0],[0,852.0,715.6,55.0],[1302.0,1875.8,1]],[69.9552,180.0,[1,1860.1,698.0,0.0],[0,863.0,714.8,55.0],[1302.0,1866.1,1]],[71.0762,180.0,[1,1850.4,698.0,0.0],[0,874.0,713.9,55.0],[1302.0,1856.4,1]],[72.1973,180.0,[1,1840.5,698.0,0.0],[0,885.0,712.2,55.0],[1302.0,1846.5,1]],[73.3184,180.0,[1,1830.8,698.0,0.0],[0,896.0,711.5,55.0],[1302.0,1836.8,1]],[74.4395,180.0,[1,1821.4,698.0,0.0],[0,908.0,711.3,55.0],[1302.0,1827.4,1]],[75.5605,180.0,[1,1812.4,698.0,0.0],[0,920.0,711.6,55.0],[1302.0,1818.4,1]],[76.6816,180.0,[1,1803.6,698.0,0.0],[0,932.0,711.0,55.0],[1302.0,1809.6,1]],[77.8027,180.0,[1,1794.9,698.0,0.0],[0,945.0,710.8,55.0],[1302.0,1800.9,1]],[78.9238,180.0,[1,1786.2,698.0,0.0],[0,958.0,691.8,55.0],[1302.0,1792.2,1]],[80.0448,180.0,[1,1777.6,698.0,0.0],[0,972.0,691.6,55.0],[1302.0,1783.6,1]],[81.1659,180.0,[1,1768.9,698.0,0.0],[0,986.0,691.8,55.0],[1302.0,1774.9,1]],[82.287,180.0,[1,1760.2,698.0,0.0],[0,1002.0,692.5,55.0],[1302.0,1766.2,1]],[83.4081,180.0,[1,1751.5,698.0,0.0],[0,1018.0,693.0,55.0],[1302.0,1757.5,1]],[84.5291,180.0,[1,1742.8,698.0,0.0],[0,1036.0,693.8,55.0],[1302.0,1748.8,1]],[85.6502,180.0,[1,1734.2,698.0,0.0],[0,1056.0,694.9,53.0],[1302.0,1740.2,1]],[86.7713,180.0,[1,1725.5,698.0,0.0],[0,1078.0,696.9,42.8],[1302.0,1731.5,1]],[87.8924,180.0,[1,1716.8,698.0,0.0],[0,1103.0,699.0,32.6],[1302.0,1722.8,1]],[89.0135,180.0,[1,1708.1,698.0,0.0],[0,1131.0,698.2,22.4],[1302.0,1714.1,1]],[90.1345,180.0,[1,1699.4,698.0,0.0],[0,1167.0,697.1,12.2],[1302.0,1705.4,1]],[91.2556,180.0,[1,1690.7,698.0,0.0],[0,1227.0,698.0,2.0],[1302.0,1696.7,1]],[91.4798,180.0,[1,1689.0,698.0,0.0],[0,1342.0,698.0,0],[1302.0,1695.0,1]],[92.3767,180.0,[1,1682.0,698.0,0.0],[0,1342.0,698.0,0],[1688.0,1688.0,1]],[92.3812,180.0,[1,1682.0,698.0,0.0],[],[1302.0,1302.0,1]],[94.3946,180.0,[1,1682.0,698.0,0.0],[],[1302.0,1302.0,1]],[94.3969,180.0,[1,1681.9,698.0,0.0],[],[0,0,1]],[94.5816,180.35,[1,1682.4,695.7,0.002],[],[0,0,1]],[94.7682,181.48,[1,1684.2,688.2,0.011],[],[0,0,1]],[94.9552,183.55,[1,1684.4,674.6,0.032],[],[0,0,1]],[95.1422,186.76,[1,1685.9,653.5,0.069],[],[0,0,1]],[95.3287,191.36,[1,1684.8,623.6,0.128],[],[0,0,1]],[95.5157,197.65,[1,1673.4,583.4,0.217],[],[0,0,1]],[95.7027,205.99,[1,1646.1,532.6,0.346],[],[0,0,1]],[95.8892,216.68,[1,1591.1,472.8,0.523],[],[0,0,1]],[96.0762,229.77,[1,1496.5,410.7,0.754],[],[0,0,1]],[96.2632,244.73,[1,1357.9,358.3,1.0],[],[0,0,1]],[96.4498,260.42,[1,1153.9,328.5,1.0],[],[0,0,1]],[96.6368,275.53,[1,977.9,326.2,1.0],[],[0,0,1]],[96.8238,289.19,[1,881.9,346.5,1.0],[],[0,0,1]],[97.0103,301.09,[1,825.9,380.7,1.0],[],[0,0,1]],[97.1973,311.28,[1,789.9,421.1,1.0],[],[0,0,1]],[97.3843,319.95,[1,761.9,462.4,1.0],[],[0,0,1]],[97.5709,327.3,[1,737.9,501.8,1.0],[],[0,0,1]],[97.7578,333.52,[1,713.9,537.8,1.0],[],[0,0,1]],[97.9448,338.8,[1,689.9,569.8,1.0],[],[0,0,1]],[98.1314,343.25,[1,669.9,597.8,1.0],[],[0,0,1]],[98.3184,347.0,[1,657.9,621.8,1.0],[],[0,0,1]],[98.5054,350.14,[1,649.9,642.1,1.0],[],[0,0,1]],[98.6919,352.73,[1,645.9,659.1,1.0],[],[0,0,1]],[98.8789,354.85,[1,641.9,673.0,1.0],[],[0,0,1]],[99.0659,356.55,[1,641.9,684.2,1.0],[],[0,0,1]],[99.2525,357.86,[1,641.9,692.9,1.0],[],[0,0,1]],[99.4395,358.84,[1,641.9,699.3,1.0],[],[0,0,1]],[99.6265,359.5,[1,641.9,703.7,1.0],[],[0,0,1]],[99.813,359.88,[1,641.9,706.2,1.0],[],[0,0,1]],[100.0,360.0,[0,639.0,700.2,0],[],[0,0,1]]]};

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) {
      n.className = cls;
      if (/(^| )grba-l( |$)/.test(cls)) n.style.cssText = 'position:absolute;inset:0;width:100%;height:100%';
    }
    return n;
  }
  function pc(v) { return v + '%'; }

  /* Place a node on the 700x2032 grid. Position is set inline as well as in the
     stylesheet so a slow CSS load can never let these layers fall into flow. */
  function place(n, box) {
    n.style.position = 'absolute';
    n.style.left = pc(box[0] / VW * 100);
    n.style.top = pc(box[1] / VH * 100);
    n.style.width = pc(box[2] / VW * 100);
    n.style.height = pc(box[3] / VH * 100);
  }

  /* Show exactly `box` of the base PNG inside a node the size of that box.
     Percentage background-position aligns image% to container%, which solves to
     x = 100*l/(VW-w) — see the derivation in the build notes. */
  function windowInto(n, box, url, prop) {
    var l = box[0], t = box[1], w = box[2], h = box[3];
    var size = (VW / w * 100) + '% ' + (VH / h * 100) + '%';
    var pos = (100 * l / (VW - w)) + '% ' + (100 * t / (VH - h)) + '%';
    if (prop === 'mask') {
      n.style.webkitMaskImage = n.style.maskImage = 'url("' + url + '")';
      n.style.webkitMaskSize = n.style.maskSize = size;
      n.style.webkitMaskPosition = n.style.maskPosition = pos;
      n.style.webkitMaskRepeat = n.style.maskRepeat = 'no-repeat';
    } else {
      n.style.backgroundImage = 'url("' + url + '")';
      n.style.backgroundSize = size;
      n.style.backgroundPosition = pos;
    }
  }

  /* An SVG image whose alpha is 0 over each hole — used as mask-image on the PNG. */
  function holeMask(holes) {
    var cut = holes.map(function (h) {
      return h.r
        ? '<circle cx="' + h.cx + '" cy="' + h.cy + '" r="' + h.r + '" fill="#000"/>'
        : '<rect x="' + h.x + '" y="' + h.y + '" width="' + h.w + '" height="' + h.h + '" fill="#000"/>';
    }).join('');
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + VW + ' ' + VH + '" preserveAspectRatio="none">' +
      '<mask id="m" maskUnits="userSpaceOnUse" x="0" y="0" width="' + VW + '" height="' + VH + '">' +
      '<rect width="' + VW + '" height="' + VH + '" fill="#fff"/>' + cut + '</mask>' +
      '<rect width="' + VW + '" height="' + VH + '" fill="#fff" mask="url(#m)"/></svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  /* The wind filter is shared by every barometer on the page. */
  function ensureDefs() {
    if (document.getElementById('grba-wind')) return;
    var d = el('div');
    d.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">' +
      '<filter id="grba-wind" x="-16%" y="-22%" width="132%" height="144%" color-interpolation-filters="sRGB">' +
      '<feTurbulence type="fractalNoise" baseFrequency="0.007 0.016" numOctaves="2" seed="7" result="t">' +
      '<animate attributeName="baseFrequency" dur="11s" values="0.007 0.016;0.010 0.021;0.007 0.016" repeatCount="indefinite"/>' +
      '</feTurbulence>' +
      '<feDisplacementMap in="SourceGraphic" in2="t" xChannelSelector="R" yChannelSelector="G" scale="2.4">' +
      '<animate attributeName="scale" dur="6.2s" values="1.5;3.4;1.5" repeatCount="indefinite"/>' +
      '</feDisplacementMap></filter></svg>';
    document.body.appendChild(d);
  }

  function build(stage) {
    var img = stage.querySelector('img.grb-img');
    if (!img || !img.src || stage.querySelector('.grba')) return;

    var root = el('div', 'grba');
    root.setAttribute('aria-hidden', 'true');
    root.style.cssText = 'position:absolute;inset:0;pointer-events:none';
    var holes = [];

    /* ── longevity ─────────────────────────────────────────────────────────
       The glass turns; the sand never does. Each bulb's sand is the whole bulb packed full, on an inner layer
       that turns with the glass, inside an outer layer that stays level with the page and lets through only
       what lies below the sand's surface. So the surface is always level, the pile under the stream is a cone,
       and when the glass is turned the sand runs down into the other bulb instead of hanging from the base.
       All of it is one looping set of keyframes (hgStyle), so off screen it pauses where it is. */
    var hbox = G.hourglass.box;
    var hg = el('div', 'grba-el grba-hg');
    place(hg, [hbox[0] - 0.6, hbox[1] - 0.6, hbox[2] + 1.2, hbox[3] + 1.2]);
    var rot = el('div', 'grba-hg-rot grba-anim');
    var frame = el('img', 'grba-l');
    frame.src = HG2.frame; frame.alt = ''; frame.decoding = 'async';
    rot.appendChild(frame); hg.appendChild(rot);
    ['a', 'b'].forEach(function (k) {
      var outer = el('div', 'grba-hg-s grba-hg-s' + k + ' grba-anim');
      var inner = el('div', 'grba-hg-in grba-anim');
      var sand = el('img', 'grba-l grba-hg-sand' + k);
      sand.src = HG2.sand; sand.alt = ''; sand.decoding = 'async';
      inner.appendChild(sand); outer.appendChild(inner); hg.appendChild(outer);
    });
    var stream = el('div', 'grba-hg-st grba-anim');
    var grains = el('i', 'grba-anim');
    grains.style.backgroundImage = 'url("' + HG2.stream + '")';
    stream.appendChild(grains); hg.appendChild(stream);
    root.appendChild(hg);
    holes.push({ x: hbox[0] - 2, y: hbox[1] - 2, w: hbox[2] + 4, h: hbox[3] + 4 });

    /* ── sillage ───────────────────────────────────────────────────────────
       Torso and gown are separate so she can take a real step: the body rises
       twice per stride, the gown swings from her hips a beat behind it, and
       the veil rides along on top of all of it. */
    var sbox = G.sillage.box;
    var sil = el('div', 'grba-el grba-sil');
    place(sil, sbox);
    var body = el('div', 'grba-sil-body grba-anim');
    var veil = el('img', 'grba-l grba-sil-veil grba-anim grba-wind');
    var skirt = el('img', 'grba-l grba-sil-skirt grba-anim');
    var upper = el('img', 'grba-l grba-sil-upper grba-anim');
    veil.src = A.veil; skirt.src = A.skirt; upper.src = A.upper;
    veil.alt = skirt.alt = upper.alt = '';
    veil.decoding = skirt.decoding = upper.decoding = 'async';
    body.appendChild(veil); body.appendChild(skirt); body.appendChild(upper);
    sil.appendChild(body); root.appendChild(sil);
    holes.push({ x: sbox[0] - 2, y: sbox[1] - 2, w: sbox[2] + 4, h: sbox[3] + 4 });

    /* ── sun, moon, seasons ────────────────────────────────────────────── */
    Object.keys(G.windows).forEach(function (k) {
      var box = G.windows[k];
      var n = el('div', 'grba-el grba-win grba-anim grba-' + k);
      place(n, box);
      if (k === 'sun') {
        /* The rays turn; the face stays level. Both are circular crops of the
           same window, so this costs nothing extra to load. */
        var rays = el('i', 'grba-sun-rays grba-anim');
        var face = el('i', 'grba-sun-face');
        windowInto(rays, box, img.src, 'bg');
        windowInto(face, box, img.src, 'bg');
        n.appendChild(rays); n.appendChild(face);
        n.classList.remove('grba-anim');
      } else if (k === 'winter') {
        /* turning on one timescale, settling on another */
        var drift = el('i', 'grba-winter-drift grba-anim');
        windowInto(drift, box, img.src, 'bg');
        n.appendChild(drift);
      } else {
        windowInto(n, box, img.src, 'bg');
      }
      if (k === 'spring') {
        for (var p = 0; p < 3; p++) {
          var pe = el('i', 'grba-petal grba-anim');
          pe.style.left = pc(34 + p * 17);
          pe.style.top = pc(30 + p * 13);
          pe.style.animationDelay = (p * 1.7).toFixed(2) + 's';
          n.appendChild(pe);
        }
      }
      root.appendChild(n);
      holes.push({ x: box[0] - 1.5, y: box[1] - 1.5, w: box[2] + 3, h: box[3] + 3 });
    });

    /* ── occasion wheel ───────────────────────────────────────────────────
       GR occasion coins 2026-10-24 (Claude): the lit-medallion animations that
       lived here cropped the OLD icons out of the picture, so they went when
       the six coins got new icons. The coins are drawn by the "occasion coins"
       block at the end of this file. */

    /* Punch the baked art out only once our replacements are in the DOM. */
    var mask = holeMask(holes);
    img.style.webkitMaskImage = img.style.maskImage = 'url("' + mask + '")';
    img.style.webkitMaskSize = img.style.maskSize = '100% 100%';
    img.style.webkitMaskRepeat = img.style.maskRepeat = 'no-repeat';

    var svg = stage.querySelector('svg.grb-txt');
    if (svg) stage.insertBefore(root, svg); else stage.appendChild(root);

    return { root: root };
  }

  /* ── the hourglass cycle as keyframes, built once per page from HG2K ── */
  function hgStyle() {
    if (document.getElementById('grba-hg2')) return;
    var W = HG_W, H = HG_H, K = HG2K, KP = 0.75, KC = 0.6, E = 14;
    var XL = -0.05 * W, XR = 1.05 * W, YB = 1.05 * H;
    var ST0 = 1290, STH = 945, STW = 44, SHIFT = (698 - 707) / STW;
    function pct(v, d) { return +(v * 100 / d).toFixed(3) + '%'; }
    function poly(q) {
      var p, w, a, x, f;
      if (!q.length) p = [[XL, 2 * H], [XL, 2 * H], [XL, 2 * H], [XR, 2 * H], [XR, 2 * H]];
      else if (q[0] === 0) {
        w = q[3] / KC;
        p = [[XL, q[1]], [q[2] - w, q[1]], [q[2], q[1] + q[3]], [q[2] + w, q[1]], [XR, q[1]]];
      } else {
        a = q[1]; x = q[2]; f = 1 - q[3];
        p = [[XL, a + (x - XL) * KP * f], [x - E, a + E * KP * 0.55 * f], [x, a],
             [x + E, a + E * KP * 0.55 * f], [XR, a + (XR - x) * KP * f]];
      }
      p.push([XR, YB], [XL, YB]);
      return 'polygon(' + p.map(function (v) { return pct(v[0], W) + ' ' + pct(v[1], H); }).join(',') + ')';
    }
    function flow(s) {
      return 'clip-path:inset(' + pct(s[0] - ST0, STH) + ' 0 ' + pct(ST0 + STH - s[1], STH) + ' 0);' +
        'transform:translateX(' + (s[2] ? (SHIFT * 100).toFixed(2) : 0) + '%)';
    }
    var t = '', a = '', b = '', s = '';
    K.k.forEach(function (r) {
      var at = r[0] + '%{';
      t += at + 'transform:rotate(' + r[1] + 'deg)}';
      a += at + 'clip-path:' + poly(r[2]) + '}';
      b += at + 'clip-path:' + poly(r[3]) + '}';
      s += at + flow(r[4]) + '}';
    });
    /* longhands only: animation-play-state stays with the .grba / .grba-live rules in gr-baro-anim.css */
    var L = 'animation-duration:' + K.c + 's;animation-timing-function:linear;animation-iteration-count:infinite;';
    var css = '.grba-hg-rot,.grba-hg-in{animation-name:grba-hg2-turn;' + L + '}' +
      '.grba-hg-sa{animation-name:grba-hg2-a;' + L + 'clip-path:' + poly(K.k[0][2]) + '}' +
      '.grba-hg-sb{animation-name:grba-hg2-b;' + L + 'clip-path:' + poly(K.k[0][3]) + '}' +
      '.grba-hg-st{animation-name:grba-hg2-s;' + L + 'clip-path:inset(0 0 100% 0)}' +
      '@keyframes grba-hg2-turn{' + t + '}@keyframes grba-hg2-a{' + a + '}' +
      '@keyframes grba-hg2-b{' + b + '}@keyframes grba-hg2-s{' + s + '}';
    var tag = document.createElement('style');
    tag.id = 'grba-hg2';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var stages = document.querySelectorAll('.grx-baro .grb-stage');
    if (!stages.length) return;
    ensureDefs();
    hgStyle();
    for (var i = 0; i < stages.length; i++) {
      (function (stage) {
        var parts = build(stage);
        if (!parts) return;
        if (!('IntersectionObserver' in window)) {
          parts.root.classList.add('grba-live'); return;
        }
        /* Off screen every layer pauses where it is, the hourglass included
           (it is keyframes now, not timers), and picks up from there. */
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { parts.root.classList.add('grba-live'); }
            else { parts.root.classList.remove('grba-live'); }
          });
        }, { rootMargin: '120px 0px', threshold: 0.02 }).observe(stage);
      })(stages[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* GR desk-1009 aud-pdp #2 (Claude 2026-10-11, owner approved; owner rule 10-07: no pills, 90 degree corners).
 * Square ends on the barometer bars: Longevity, Sillage, day/night and the four seasons.
 *
 * Those seven bars are not HTML. They are painted, with round caps, into each product's barometer PNG
 * (bargfx-<handle>-oilphoto3x.png, 1400x4064, in Shopify Files and referenced from 16 languages of product
 * descriptions). Re-rendering 167 PNGs would be a live product-data write, so this stays in the theme instead and
 * leaves the PNG and the descriptions untouched:
 *   1. once the barometer image has loaded, read the same file again through an anonymous-CORS Image (cdn.shopify.com
 *      answers "access-control-allow-origin: *", and an image request sends the browser's own image Accept header,
 *      so it is served from the HTTP cache: no second download);
 *   2. find the bars: rows where four sample columns (45/55/65/75% of the width) are all solid, grouped into bands
 *      16..80 px tall at 1400 px (plus their soft antialiased edge rows and cap tips, so no sliver of the old round
 *      end shows past the square one). Every one of the 167 live barometers has exactly 7 such bands at the same place;
 *      anything else is unknown art and is left alone;
 *   3. for each bar take its middle row from tip to tip (fill colour, the fill/track boundary at the fill's own tip,
 *      track colour, or the day-to-night blend) and lay that row over the bar as a 1 px tall canvas stretched to the
 *      bar's height. Every column becomes one flat colour, so the bar keeps its length, colours and fill and only its
 *      round ends turn square;
 *   4. mask the old round bars out of the PNG underneath (a second mask layer next to the animation engine's icon
 *      holes), so no antialiased sliver of a round tip survives on a downscaled phone render.
 * It sits above the PNG and below the icons, labels and tap targets. Static, no animation; it also runs for visitors
 * who ask for reduced motion. Any failure (no CORS, decode error, an unexpected layout) leaves today's round bars.
 * Rollback: delete this block. */
(function () {
  'use strict';
  if (window.__grbsqBooted) return;
  window.__grbsqBooted = 1;
  var COLS = [0.45, 0.55, 0.65, 0.75], BARS = 7;

  function solidRow(d, y, n, a) {
    for (var i = 0; i < n; i++) if (d[(y * n + i) * 4 + 3] < a) return false;
    return true;
  }

  function paint(stage, img, im) {
    if (stage.querySelector('.grbsq')) return;
    var W = im.naturalWidth, H = im.naturalHeight, s = W / 1400, n = COLS.length, i, y;
    if (W < 700 || H < 1400) return;
    var cv = document.createElement('canvas');
    var cx = cv.getContext('2d', { willReadFrequently: true });
    if (!cx) return;
    cv.width = n; cv.height = H;
    for (i = 0; i < n; i++) cx.drawImage(im, Math.floor(W * COLS[i]), 0, 1, H, i, 0, 1, H);
    var col = cx.getImageData(0, 0, n, H).data;
    var bands = [];
    for (y = 0; y < H; y++) {
      if (!solidRow(col, y, n, 128)) continue;
      var y0 = y;
      while (y + 1 < H && solidRow(col, y + 1, n, 128)) y++;
      var h = y - y0 + 1;
      if (h < 16 * s || h > 80 * s) continue;
      /* take in the bar's soft top and bottom edge rows too (at most 3 each), so the square bar is one crisp block */
      var t = y0, u = y;
      while (t > 0 && y0 - t < 3 && solidRow(col, t - 1, n, 8)) t--;
      while (u + 1 < H && u - y < 3 && solidRow(col, u + 1, n, 8)) u++;
      bands.push([t, u]);
    }
    if (bands.length !== BARS) return;
    cv.width = W; cv.height = 1;
    var bars = [], boxes = [];
    for (i = 0; i < bands.length; i++) {
      var b0 = bands[i][0], b1 = bands[i][1], ym = (b0 + b1) >> 1;
      cx.clearRect(0, 0, W, 1);
      cx.drawImage(im, 0, ym, W, 1, 0, 0, W, 1);
      var row = cx.getImageData(0, 0, W, 1).data;
      var c = Math.floor(W * 0.55), s0 = c, e0 = c;
      while (s0 > 0 && row[(s0 - 1) * 4 + 3] >= 128) s0--;
      while (e0 < W - 1 && row[(e0 + 1) * 4 + 3] >= 128) e0++;
      if (e0 - s0 + 1 < 0.4 * W) return;
      /* and the soft tip pixels of the round caps (at most 4 each side), painted in the end colour */
      var xs = s0, xe = e0;
      while (xs > 0 && s0 - xs < 4 && row[(xs - 1) * 4 + 3] >= 8) xs--;
      while (xe < W - 1 && xe - e0 < 4 && row[(xe + 1) * 4 + 3] >= 8) xe++;
      var bw = xe - xs + 1;
      var bar = document.createElement('canvas');
      bar.width = bw; bar.height = 1;
      var bx = bar.getContext('2d');
      if (!bx) return;
      var id = bx.createImageData(bw, 1), px = id.data;
      for (var x = 0; x < bw; x++) {
        var k = Math.min(Math.max(xs + x, s0), e0) * 4, o = x * 4;
        px[o] = row[k]; px[o + 1] = row[k + 1]; px[o + 2] = row[k + 2]; px[o + 3] = 255;
      }
      bx.putImageData(id, 0, 0);
      bar.className = 'grbsq';
      bar.setAttribute('aria-hidden', 'true');
      bar.style.cssText = 'position:absolute;display:block;margin:0;padding:0;border:0;border-radius:0;pointer-events:none;' +
        'left:' + (xs / W * 100) + '%;top:' + (b0 / H * 100) + '%;width:' + (bw / W * 100) + '%;height:' + ((b1 - b0 + 1) / H * 100) + '%';
      bars.push(bar);
      boxes.push([xs, b0, bw, b1 - b0 + 1]);
    }
    cv.width = cv.height = 0;
    var before = img.nextSibling;
    for (i = 0; i < bars.length; i++) stage.insertBefore(bars[i], before);
    /* Punch the old round bars out of the PNG (3 px larger than the square ones), so not even a faint antialiased
       pixel of a round tip shows beside the square end on a downscaled phone render. The animation engine above may
       already mask this image for its icons: the bar holes are added as a second mask layer, intersected with it. */
    var cut = '';
    for (i = 0; i < boxes.length; i++) {
      var q = boxes[i];
      cut += '<rect x="' + (q[0] - 3) + '" y="' + (q[1] - 3) + '" width="' + (q[2] + 6) + '" height="' + (q[3] + 6) + '" fill="#000"/>';
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none">' +
      '<mask id="m" maskUnits="userSpaceOnUse" x="0" y="0" width="' + W + '" height="' + H + '">' +
      '<rect width="' + W + '" height="' + H + '" fill="#fff"/>' + cut + '</mask>' +
      '<rect width="' + W + '" height="' + H + '" fill="#fff" mask="url(#m)"/></svg>';
    var url = 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg) + '")';
    var st = img.style, prev = st.maskImage || st.webkitMaskImage;
    if (prev && prev !== 'none') {
      st.webkitMaskImage = st.maskImage = prev + ', ' + url;
      st.webkitMaskSize = st.maskSize = '100% 100%, 100% 100%';
      st.webkitMaskRepeat = st.maskRepeat = 'no-repeat, no-repeat';
      st.webkitMaskComposite = 'source-in';
      st.maskComposite = 'intersect';
    } else {
      st.webkitMaskImage = st.maskImage = url;
      st.webkitMaskSize = st.maskSize = '100% 100%';
      st.webkitMaskRepeat = st.maskRepeat = 'no-repeat';
    }
  }

  function square(stage) {
    var img = stage.querySelector('img.grb-img');
    if (!img || stage.__grbsq) return;
    stage.__grbsq = 1;
    var go = function () {
      var src = img.currentSrc || img.src;
      if (!src || !img.naturalWidth) return;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () { try { paint(stage, img, im); } catch (e) { /* keep the round bars */ } im.onload = im.onerror = null; };
      im.onerror = function () { im.onload = im.onerror = null; };
      im.src = src;
    };
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }

  function init() {
    var stages = document.querySelectorAll('.grx-baro .grb-stage');
    for (var i = 0; i < stages.length; i++) square(stages[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* GR occasion coins + splice repair (Claude 2026-10-24; owner: "use all six new icons").
 *
 * The occasion wheel stays exactly as it is baked into every product's barometer picture: the big circle, the six
 * coins with their gold rings, the centre words, the tap targets and the popovers. Only what is INSIDE each coin
 * changes: the picture is cut away inside radius 96 of each coin (the gold ring is hard-edged at 96.25..98.25 and the
 * old icons never reach 77) and a new icon is laid on a disc of the picture's own cream. Lit coins (gold ring present)
 * show their icon in full; unlit coins show it at 40%, as the old ghosts were. Which coins are lit is read from the
 * picture itself, the canonical source, through the same anonymous-CORS copy the square-bar block uses.
 *
 * The new cast: a black lacquer feather mask (experimental), tortoiseshell spectacles (office), a black lace fan
 * (evening), a South Sea pearl strand (romantic), a black silk top hat (formal), a straw Panama (casual).
 *
 * Coin motion (Claude 2026-10-25; owner: the new icons were the only still things in the barometer). As with the old
 * medallions, only a LIT coin moves, and only as its object would: the feather sways from its quill while the lacquer
 * mask holds still; the fan breathes open and closed about its rivet, the outer guards most, the head never; the
 * straw brim lifts in a breeze while the crown and its band hold still; the top hat rocks on its curled brim; the
 * folded spectacles rock on their rims and settle; the pearl rope turns on its tray, in the tray's own plane. Where
 * only part of an object moves, the still part and the moving part are two masked copies of the same icon, so at
 * rest they are the icon exactly. Paused off screen; none of it for reduced motion (the coins are then as before).
 *
 * Splice repair, same pass: 26 pictures (the 13 re-spliced on 2026-09-14 as -oilphoto32 and 13 newer gr-baro-* files)
 * were assembled with a horizontal seam at y 442.5 of the 700x2032 grid (pixel row 885 of 4064), through the top of
 * the experimental coin. 24 carry a stray gold arc over an unlit experimental coin (cut away here), 2 a lit
 * experimental ring missing its top (drawn back here, flat-ended at the seam like the picture's own ring).
 *
 * Nothing is swapped until the six icons are decoded, then everything changes in one frame, so a visitor never sees
 * an empty coin. If anything fails (no CORS, an icon that will not load, an unexpected picture) the wheel stays as
 * baked. Runs for every visitor, including reduced motion. Rollback: delete this block and restore the occasion
 * section of the engine and of gr-baro-anim.css from gr-occasions-1024/backups/main-2026-10-24. */
(function () {
  'use strict';
  if (window.__grcoinBooted) return;
  window.__grcoinBooted = 1;
  var VW = 700, VH = 2032, RAD = Math.PI / 180;
  var KEYS = ['experimental', 'office', 'evening', 'romantic', 'formal', 'casual'];
  /* coin centres, measured on the live 1400x4064 art from the hard edges of the lit rings (the renderer rounded each
     centre to a whole pixel, hence the quarters) */
  var C = { experimental: [350.25, 528.25], office: [543.75, 640.25], evening: [543.75, 864.25],
            romantic: [350.25, 976.25], formal: [156.25, 864.25], casual: [156.25, 640.25] };
  var HOLE = 96, GHOST = 0.40, SEAM = 442.5, RING = 97.25, RW = 2;
  var ART = window.GRCOIN_ART || {
    experimental: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-experimental-black-lacquer-feather-mask.webp?v=1792864075",
    office: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-office-tortoiseshell-spectacles.webp?v=1792864078",
    evening: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-evening-black-lace-fan.webp?v=1792864081",
    romantic: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-romantic-south-sea-pearl-strand.webp?v=1792864084",
    formal: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-formal-black-silk-top-hat.webp?v=1792864088",
    casual: "https://cdn.shopify.com/s/files/1/0937/0340/5861/files/occasion-casual-straw-panama-hat.webp?v=1792864091"
  };
  function pc(v) { return v + '%'; }
  function isGold(d, k) { return d[k + 3] > 60 && d[k] > d[k + 1] && d[k + 1] > d[k + 2] && d[k] - d[k + 2] > 40; }

  /* One small canvas per coin: is its ring there (and, for the experimental coin, above and below the seam), and
     what colour is its disc. */
  function readCoins(im) {
    var W = im.naturalWidth, H = im.naturalHeight;
    if (W < 700 || Math.abs(H / W - VH / VW) > 0.01) return null;
    var S = W / VW, box = Math.ceil(212 * S);
    var cv = document.createElement('canvas');
    cv.width = box; cv.height = box;
    var c = cv.getContext('2d', { willReadFrequently: true });
    if (!c) return null;
    var out = {};
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i], cx = C[k][0] * S, cy = C[k][1] * S;
      var x0 = Math.round(cx - box / 2), y0 = Math.round(cy - box / 2);
      c.clearRect(0, 0, box, box);
      c.drawImage(im, x0, y0, box, box, 0, 0, box, box);
      var d = c.getImageData(0, 0, box, box).data;
      var hits = 0, above = 0, nAbove = 0, below = 0, nBelow = 0;
      for (var deg = 0; deg < 360; deg += 2) {
        var hit = false;
        for (var rr = 95; rr <= 100 && !hit; rr += 0.5) {
          var px = Math.floor(cx + rr * S * Math.cos(deg * RAD)) - x0, py = Math.floor(cy + rr * S * Math.sin(deg * RAD)) - y0;
          if (px >= 0 && py >= 0 && px < box && py < box && isGold(d, (py * box + px) * 4)) hit = true;
        }
        if (hit) hits++;
        var y = C[k][1] + RING * Math.sin(deg * RAD);
        if (y < SEAM - 1) { nAbove++; if (hit) above++; } else if (y > SEAM + 3) { nBelow++; if (hit) below++; }
      }
      /* disc: median of twelve samples at radius 90, between the old icon (<77) and the ring (>96) */
      var rs = [], gs = [], bs = [], as = [];
      for (var j = 0; j < 12; j++) {
        var qx = Math.floor(cx + 90 * S * Math.cos((j * 30 + 15) * RAD)) - x0, qy = Math.floor(cy + 90 * S * Math.sin((j * 30 + 15) * RAD)) - y0;
        var q = (qy * box + qx) * 4; rs.push(d[q]); gs.push(d[q + 1]); bs.push(d[q + 2]); as.push(d[q + 3]);
      }
      var med = function (a) { a.sort(function (m, n) { return m - n; }); return a[6]; };
      out[k] = { ring: hits / 180, above: nAbove ? above / nAbove : 0, below: nBelow ? below / nBelow : 0,
                 disc: [med(rs), med(gs), med(bs), med(as)] };
    }
    cv.width = cv.height = 0;
    return out;
  }

  function addMask(img, inner) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + VW + ' ' + VH + '" preserveAspectRatio="none">' +
      '<mask id="m" maskUnits="userSpaceOnUse" x="0" y="0" width="' + VW + '" height="' + VH + '">' +
      '<rect width="' + VW + '" height="' + VH + '" fill="#fff"/>' + inner + '</mask>' +
      '<rect width="' + VW + '" height="' + VH + '" fill="#fff" mask="url(#m)"/></svg>';
    var url = 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg) + '")';
    var st = img.style, prev = st.maskImage || st.webkitMaskImage;
    if (prev && prev !== 'none') {
      st.webkitMaskImage = st.maskImage = prev + ', ' + url;
      st.webkitMaskSize = st.maskSize = '100% 100%';            /* a one-value list repeats for every layer */
      st.webkitMaskRepeat = st.maskRepeat = 'no-repeat';
      st.webkitMaskComposite = 'source-in';
      st.maskComposite = 'intersect';
    } else {
      st.webkitMaskImage = st.maskImage = url;
      st.webkitMaskSize = st.maskSize = '100% 100%';
      st.webkitMaskRepeat = st.maskRepeat = 'no-repeat';
    }
  }

  /* The six icons, loaded once per page and decoded before anything is shown. */
  var icons = null;
  function loadIcons() {
    if (icons) return icons;
    icons = Promise.all(KEYS.map(function (k) {
      var im = new Image();
      im.decoding = 'async';
      im.src = ART[k];
      return (im.decode ? im.decode() : new Promise(function (ok, no) { im.onload = ok; im.onerror = no; }))
        .then(function () { if (!im.naturalWidth) throw new Error('empty ' + k); return { key: k, img: im }; });
    })).then(function (list) { var o = {}; list.forEach(function (x) { o[x.key] = x.img; }); return o; });
    return icons;
  }

  function f3(v) { return v.toFixed(3); }

  /* ── coin motion ────────────────────────────────────────────────────────
     Geometry is in each icon's own pixels; the keyframes are in gr-baro-anim.css. */
  var STILL = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* the feather, from its quill's root in the gold boss up; drawn below the mask, so it tucks behind the trim */
  var FEATHER = 'M0 0H240V200L180 240L175 243L165 244L150 247L140 251L130 252L120 257L115 261L110 268L105 269L100 275' +
                'L95 280L90 281L85 282L78 281L70 284L64 290L55 296H0Z';
  /* the fan: one angular slice per stick about the rivet (CSS conic angles, 0 = up; the stick whole inside its slice,
     the hand-over to the next slice across the lace between them), [start, stops]; the last is the head, which stays.
     Each stick turns in proportion to its angle (gr-baro-anim.css), so the fan spreads and closes like a fan. */
  var RIVET = '50.5625% 90.1812%', FAN = [
    [-100, '8deg,#000 23deg,transparent 27.25deg'], [-77, '4.25deg,#000 10.75deg,transparent 20.25deg'],
    [-66.25, '9.5deg,#000 16deg,transparent 22.5deg'], [-50.25, '6.5deg,#000 12.5deg,transparent 18.25deg'],
    [-37.75, '5.75deg,#000 11.75deg,transparent 16.27deg'], [-26, '4.52deg,#000 10.72deg,transparent 15.25deg'],
    [-15.28, '4.53deg,#000 11.03deg,transparent 16.03deg'], [-4.25, '5deg,#000 11.5deg,transparent 16.5deg'],
    [7.25, '5deg,#000 11deg,transparent 15.5deg'], [18.25, '4.5deg,#000 11deg,transparent 15.25deg'],
    [29.25, '4.25deg,#000 10.75deg,transparent 15.47deg'], [40, '4.72deg,#000 10.52deg,transparent 14.52deg'],
    [50.52, '4deg,#000 10.2deg,transparent 15deg'], [60.72, '4.8deg,#000 11deg,transparent 15.53deg'],
    [71.72, '4.53deg,#000 20.28deg,transparent 28.28deg'], [92, '8deg,#000 168deg,transparent 176deg']];

  function svgMask(w, h, inner) {
    return 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" ' +
      'viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="none">' + inner + '</svg>') + '")';
  }
  function part(a, cls, mask) {
    var p = a.cloneNode(false);
    p.alt = ''; p.draggable = false;
    p.className = cls;
    p.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;display:block;margin:0;padding:0;border:0;' +
      'max-width:none;pointer-events:none';
    if (mask) {
      p.style.webkitMaskImage = p.style.maskImage = mask;
      p.style.webkitMaskSize = p.style.maskSize = '100% 100%';
      p.style.webkitMaskRepeat = p.style.maskRepeat = 'no-repeat';
    }
    return p;
  }
  function cone(from, stops) {
    return 'conic-gradient(from ' + from + 'deg at ' + RIVET + ',' + stops + ')';
  }

  /* The lit coin's icon as moving parts inside one box, or null to keep the single still icon. */
  function motion(k, a) {
    if (STILL) return null;
    var w = a.naturalWidth, h = a.naturalHeight, box = document.createElement('div'), i;
    if (k === 'experimental' && w === 480 && h === 454) {
      /* moving part first (below), grown by a pixel so the quill never shows a seam where it crosses the cut */
      box.appendChild(part(a, 'grcoin-anim grcoin-feather', svgMask(w, h, '<path d="' + FEATHER +
        '" fill="#000" stroke="#000" stroke-width="2" stroke-linejoin="round"/>')));
      box.appendChild(part(a, 'grcoin-hold', svgMask(w, h, '<path fill-rule="evenodd" fill="#000" d="M0 0H' + w + 'V' + h +
        'H0Z' + FEATHER + '"/>')));
    } else if (k === 'evening' && w === 480 && h === 276) {
      /* slices sum to the whole fan at rest; added with plus-lighter, so the overlaps are exact, not double-drawn */
      if (!(window.CSS && CSS.supports && CSS.supports('mix-blend-mode', 'plus-lighter'))) return null;
      for (i = 0; i < FAN.length; i++) {
        box.appendChild(part(a, 'grcoin-fan' + (i < FAN.length - 1 ? ' grcoin-anim grcoin-fan' + i : ''),
          cone(FAN[i][0], 'transparent 0deg,#000 ' + FAN[i][1])));
      }
    } else if (k === 'casual' && w === 480 && h === 364) {
      /* the brim in front of the crown, below the band's lowest point (y 268), flexes about that line */
      box.appendChild(part(a, 'grcoin-anim grcoin-brim', 'linear-gradient(to bottom,transparent 73.0769%,#000 73.0769%)'));
      box.appendChild(part(a, 'grcoin-hold', 'linear-gradient(to bottom,#000 73.6264%,transparent 73.6264%)'));
    } else if (k === 'formal' || k === 'office' || k === 'romantic') {
      box.appendChild(part(a, 'grcoin-anim grcoin-' + { formal: 'hat', office: 'specs', romantic: 'pearls' }[k]));
    } else {
      return null;
    }
    return box;
  }

  /* the coins move only while the barometer is on screen */
  function live(stage, layer) {
    if (!('IntersectionObserver' in window)) { layer.classList.add('grcoin-live'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { layer.classList.toggle('grcoin-live', e.isIntersecting); });
    }, { rootMargin: '120px 0px', threshold: 0.02 }).observe(stage);
  }

  function apply(stage, img, coins, art) {
    var holes = '', layer = document.createElement('div');
    layer.className = 'grcoin';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:1';
    var lit = [], moves = 0;
    KEYS.forEach(function (k) {
      var cx = C[k][0], cy = C[k][1], info = coins[k], on = info.ring > 0.5;
      if (on) lit.push(k);
      holes += '<circle cx="' + cx + '" cy="' + cy + '" r="' + HOLE + '" fill="#000"/>';
      /* the disc in the picture's own cream; fall back to the measured values if the sample is not a cream disc */
      var dc = info.disc, okDisc = dc[3] > 20 && dc[3] < 120 && dc[0] > 230 && dc[1] > 225 && dc[2] > 215;
      var rgba = okDisc ? 'rgba(' + dc[0] + ',' + dc[1] + ',' + dc[2] + ',' + (dc[3] / 255).toFixed(3) + ')'
                        : (on ? 'rgba(250,246,238,0.306)' : 'rgba(250,246,238,0.165)');
      var disc = document.createElement('i');
      disc.style.cssText = 'position:absolute;display:block;border-radius:50%;background:' + rgba +
        ';left:' + pc((cx - HOLE) / VW * 100) + ';top:' + pc((cy - HOLE) / VH * 100) +
        ';width:' + pc(2 * HOLE / VW * 100) + ';height:' + pc(2 * HOLE / VH * 100);
      layer.appendChild(disc);
      /* the icon: as large as fits the coin, half-diagonal at most 78 and long side at most 150 (the old icons' box) */
      var a = art[k], w = a.naturalWidth, h = a.naturalHeight;
      var sc = Math.min(156 / Math.sqrt(w * w + h * h), 150 / Math.max(w, h)), iw = w * sc, ih = h * sc;
      var mv = on ? motion(k, a) : null, ic = mv || a.cloneNode(false);
      if (!mv) { ic.alt = ''; ic.draggable = false; }
      ic.className = 'grcoin-' + k + (on ? ' grcoin-lit' : '');
      ic.style.cssText = 'position:absolute;display:block;margin:0;padding:0;border:0;max-width:none;pointer-events:none;' +
        'opacity:' + (on ? 1 : GHOST) + ';left:' + pc((cx - iw / 2) / VW * 100) + ';top:' + pc((cy - ih / 2) / VH * 100) +
        ';width:' + pc(iw / VW * 100) + ';height:' + pc(ih / VH * 100);
      if (mv) { ic.style.isolation = 'isolate'; moves++; }
      layer.appendChild(ic);
    });
    /* splice repair, experimental coin */
    var e = coins.experimental, ex = C.experimental[0], ey = C.experimental[1], verdict = 'ok';
    if (e.below < 0.05 && e.above > 0.5) {
      /* stray arc over an unlit coin: cut everything of it above the seam within radius 99.8 (the outer hairline is
         never closer than 101.5 to this coin's centre), one unit past the seam so no resampled row leaves a tint */
      var yc = SEAM + 1, hw = Math.sqrt(99.8 * 99.8 - (ey - yc) * (ey - yc));
      holes += '<path d="M ' + f3(ex - hw) + ' ' + yc + ' A 99.8 99.8 0 0 1 ' + f3(ex + hw) + ' ' + yc + ' Z" fill="#000"/>';
      verdict = 'cut';
    } else if (e.below > 0.8 && e.above < 0.5) {
      /* lit coin whose ring stops at the seam: the ring above the seam as a filled band, flat at the seam like the
         picture's own ring, reaching a quarter unit below it so the two anti-aliased edges do not leave a hairline */
      var ro = RING + RW / 2, ri = RING - RW / 2, yb = SEAM + 0.25, db = ey - yb;
      var xo = Math.sqrt(ro * ro - db * db), xi = Math.sqrt(ri * ri - db * db);
      var band = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      band.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);
      band.setAttribute('preserveAspectRatio', 'none');
      band.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;overflow:visible';
      band.innerHTML = '<path d="M ' + f3(ex - xo) + ' ' + yb + ' A ' + ro + ' ' + ro + ' 0 0 1 ' + f3(ex + xo) + ' ' + yb +
        ' L ' + f3(ex + xi) + ' ' + yb + ' A ' + ri + ' ' + ri + ' 0 0 0 ' + f3(ex - xi) + ' ' + yb + ' Z" fill="rgb(197,164,51)" fill-opacity="0.784"/>';
      layer.appendChild(band);
      verdict = 'ring';
    }
    /* one frame: the holes, the new coins, the repair */
    addMask(img, holes);
    stage.insertBefore(layer, stage.querySelector('svg.grb-txt'));
    stage.setAttribute('data-grcoin', lit.join(' ') || 'none');
    stage.setAttribute('data-grarc', verdict);
    if (moves) live(stage, layer);
  }

  function watch(stage) {
    var img = stage.querySelector('img.grb-img');
    if (!img || stage.__grcoinWatch) return;
    stage.__grcoinWatch = 1;
    var go = function () {
      var src = img.currentSrc || img.src;
      if (!src || !img.naturalWidth) return;
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      var copy = new Promise(function (ok, no) { im.onload = function () { ok(im); }; im.onerror = no; im.src = src; });
      Promise.all([copy, loadIcons()]).then(function (r) {
        if (stage.querySelector('.grcoin')) return;
        var coins = readCoins(r[0]);
        im.onload = im.onerror = null;
        if (!coins) return;
        apply(stage, img, coins, r[1]);
      }).catch(function () { /* leave the wheel as baked */ });
    };
    if (img.complete && img.naturalWidth) go();
    else img.addEventListener('load', go, { once: true });
  }

  function init() {
    var stages = document.querySelectorAll('.grx-baro .grb-stage');
    for (var i = 0; i < stages.length; i++) watch(stages[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
